import { JBP_EXPORT_PLAN_ACTUALS_VALUE_TYPE_KEY } from '../../models/sectionSettings/sectionSettings'

export const getExportPlanActualsValueTypeKey = (programType: string, isDistributor: boolean) => {
  const suffix = isDistributor ? '' : `-${programType.trim().replace(/\s/g, '').toLowerCase()}`

  return `${JBP_EXPORT_PLAN_ACTUALS_VALUE_TYPE_KEY}${suffix}`
}
